import { resources } from "@constants/hardcoded-strings";
import { QueryParameter } from "@idw-types/common";
import { WorkflowReportSearchResultsTypes } from "@idw-types/state/workflow-report-state";
import {
    setPartialWorkflowReportSearchResultsLoading,
    setWorkflowReportSearchResultsVolumeByCountry
} from "@redux/actions/workflow-report-actions";
import { getWorkflowReportVolumesRequestByCountry } from "@requests/reports/get-workflow-report-volumes-by-country";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { Dispatch } from "redux";

export const getWorkflowReportSearchResultsVolumeByCountryReduxRequest = (dispatch: Dispatch) => async (
    queryParameters: Array<QueryParameter>
) => {
    dispatch(setPartialWorkflowReportSearchResultsLoading(true, WorkflowReportSearchResultsTypes.volumesByCountry));

    const { data: volumesByCountryData, error: volumesByCountryError } = await getWorkflowReportVolumesRequestByCountry(queryParameters);

    if (volumesByCountryData) {
        dispatch(setWorkflowReportSearchResultsVolumeByCountry(volumesByCountryData));
    } else {
        if (volumesByCountryError) {
            logAndDisplayErrorModal(
                dispatch,
                volumesByCountryData,
                resources.requests.getWorkflowReportVolumesByCountry.error.title,
                resources.requests.getWorkflowReportVolumesByCountry.error.message,
                null,
                queryParameters
            );
        }

        dispatch(setPartialWorkflowReportSearchResultsLoading(false, WorkflowReportSearchResultsTypes.volumesByCountry));
    }
};